import {
  customDynamicRepeaterFieldGetConfigurationConfig,
  customDynamicRepeaterFieldParseIntoSettingsFormModel,
  customDynamicRepeaterFieldUpdateFromSettingsFormModel,
  customDynamicRepeaterFieldParseIntoValidationFormModel,
  customDynamicRepeaterFieldUpdateFromValidationFormModel,
  customDynamicRepeaterFieldParseFieldIntoDisplayFormModel,
  customDynamicRepeaterFieldUpdateFromDisplayFormModel,
} from './form-field-formly-types-main-configurations/custom-dynamic-repeater-field-type.configuration';
import { Injector } from '@angular/core';
import { FormBuilderService } from '../../services/form-builder.service';
import {
  ICustomDynamicRepeaterConfigurationFormModel,
  ICustomRepeaterConfigurationFormModel,
  IDataTableFieldConfigurationFormModel,
  IErrorConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
  IGenericDataFetchFieldsConfigFormModel,
  IGenericLabelValueFieldsConfigFormModel,
  ITableWithInputConfigurationFormModel,
  ITableWrapperConfigurationFormModel,
  ITimePickerFieldConfig,
  TConfigurationFormModelTypes,
} from '../../models/form-builder-types-configurations.model';
import {
  sectionFieldGetConfigurationConfig,
  sectionFieldParseFieldIntoDisplayFormModel,
  sectionFieldParseIntoSettingsFormModel,
  sectionFieldUpdateFromDisplayFormModel,
  sectionFieldUpdateFromSettingsFormModel,
} from './form-field-formly-types-main-configurations/section-field-type.configuration';
import {
  radioFieldGetConfigurationConfig,
  radioFieldParseFieldIntoDisplayFormModel,
  radioFieldParseIntoSettingsFormModel,
  radioFieldParseIntoValidationFormModel,
  radioFieldUpdateFromDisplayFormModel,
  radioFieldUpdateFromSettingsFormModel,
  radioFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/radio-field-type.configuration';
import {
  multiCheckboxFieldGetConfigurationConfig,
  multiCheckboxFieldParseIntoSettingsFormModel,
  multiCheckboxFieldUpdateFromSettingsFormModel,
  multiCheckboxFieldUpdateFromDisplayFormModel,
  multiCheckboxFieldParseFieldIntoDisplayFormModel,
  multiCheckboxFieldParseIntoValidationFormModel,
  multiCheckboxFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/multicheckbox-field-type.configuration';
import {
  customDropDownFieldGetConfigurationConfig,
  customDropDownFieldParseFieldIntoDisplayFormModel,
  customDropDownFieldParseIntoSettingsFormModel,
  customDropDownFieldParseIntoValidationFormModel,
  customDropDownFieldUpdateFromDisplayFormModel,
  customDropDownFieldUpdateFromSettingsFormModel,
  customDropDownFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-dropdown-field-type.configuration';
import {
  inputFieldGetConfigurationConfig,
  inputFieldParseFieldIntoDisplayFormModel,
  inputFieldParseIntoSettingsFormModel,
  inputFieldParseIntoValidationFormModel,
  inputFieldUpdateFromDisplayFormModel,
  inputFieldUpdateFromSettingsFormModel,
  inputFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/input-field-type.configuration';
import {
  textareaFieldGetConfigurationConfig,
  textareaFieldParseFieldIntoDisplayFormModel,
  textareaFieldParseIntoSettingsFormModel,
  textareaFieldParseIntoValidationFormModel,
  textareaFieldUpdateFromDisplayFormModel,
  textareaFieldUpdateFromSettingsFormModel,
  textareaFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/textarea-field-type.configuration';
import {
  blockFieldGetConfigurationConfig,
  blockFieldParseFieldIntoDisplayFormModel,
  blockFieldParseIntoSettingsFormModel,
  blockFieldUpdateFromDisplayFormModel,
  blockFieldUpdateFromSettingsFormModel,
} from './form-field-formly-types-main-configurations/block-field-type.configuration';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { IFormFieldsValidationModel } from '../../models/form-fields-formly-validation.model';
import {
  EIremboFormlyFieldSubTypes,
  EIremboFormlyFieldTypes,
} from '@irembo-andela/irembogov3-common';
import { IFormFieldsDisplayModel } from '../../models/form-fields-formly-display.model';
import {
  nidFieldGetConfigurationConfig,
  nidFieldParseFieldIntoDisplayFormModel,
  nidFieldParseIntoSettingsFormModel,
  nidFieldParseIntoValidationFormModel,
  nidFieldUpdateFromDisplayFormModel,
  nidFieldUpdateFromSettingsFormModel,
  nidFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/nid-field-type.configuration';
import { childNidFieldGetConfigurationConfig } from './form-field-formly-types-main-configurations/child-nid-field-type.configuration';
import { ninFieldGetConfigurationConfig } from './form-field-formly-types-main-configurations/nin-field-type.configuration';
import {
  customDropDownWithDataFetchFieldGetConfigurationConfig,
  customDropDownWithDataFetchFieldParseIntoSettingsFormModel,
  customDropDownWithDataFetchFieldUpdateFromSettingsFormModel,
} from './form-field-formly-types-main-configurations/custom-dropdown-with-data-fetch-field-type.configuration';
import {
  customDropDownWithDatasetFieldGetConfigurationConfig,
  customDropDownWithDataSetFieldNonPaginatedGetConfigurationConfig,
  customDropDownWithDatasetFieldParseIntoSettingsFormModel,
  customDropDownWithDatasetFieldUpdateFromSettingsFormModel,
} from './form-field-formly-types-main-configurations/custom-dropdown-with-dataset-field-type.configuration';
import {
  customFileUploadFieldGetConfigurationConfig,
  customFileUploadFieldParseFieldIntoDisplayFormModel,
  customFileUploadFieldParseIntoSettingsFormModel,
  customFileUploadFieldParseIntoValidationFormModel,
  customFileUploadFieldUpdateFromDisplayFormModel,
  customFileUploadFieldUpdateFromSettingsFormModel,
  customFileUploadFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-file-upload-field-type.configuration';
import {
  locationWidgetFieldGetConfigurationConfig,
  locationWidgetFieldParseFieldIntoDisplayFormModel,
  locationWidgetFieldParseIntoSettingsFormModel,
  locationWidgetFieldParseIntoValidationFormModel,
  locationWidgetFieldUpdateFromDisplayFormModel,
  locationWidgetFieldUpdateFromSettingsFormModel,
  locationWidgetFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/location-widget-field-type.configuration';
import {
  internationalPhoneNumberFieldGetConfigurationConfig,
  internationalPhoneNumberFieldParseFieldIntoDisplayFormModel,
  internationalPhoneNumberFieldParseIntoSettingsFormModel,
  internationalPhoneNumberFieldParseIntoValidationFormModel,
  internationalPhoneNumberFieldUpdateFromDisplayFormModel,
  internationalPhoneNumberFieldUpdateFromSettingsFormModel,
  internationalPhoneNumberFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/international-phone-number-field-type.configuration';
import {
  datePickerFieldGetSettingsConfigurationConfig,
  datePickerFieldParseIntoSettingsFormModel,
  datePickerFieldParseIntoValidationFormModel,
  datePickerFieldUpdateFromSettingsFormModel,
  datePickerFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-datepicker-field-type.configuration';
import {
  slotBookingFieldParseIntoSettingsFormModel,
  slotBookingFieldUpdateFromSettingsFormModel,
  slotbookingGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/custom-slot-booking.configuration';
import {
  tinFieldParseFieldIntoDisplayFormModel,
  tinFieldParseIntoSettingsFormModel,
  tinFieldParseIntoValidationFormModel,
  tinFieldUpdateFromDisplayFormModel,
  tinFieldUpdateFromSettingsFormModel,
  tinFieldUpdateFromValidationFormModel,
  tinInputGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/custom-tin-input.configuration';
import {
  crvsFieldParseFieldIntoDisplayFormModel,
  crvsFieldParseIntoSettingsFormModel,
  crvsFieldParseIntoValidationFormModel,
  crvsFieldUpdateFromDisplayFormModel,
  crvsFieldUpdateFromSettingsFormModel,
  crvsFieldUpdateFromValidationFormModel,
  crvsInputGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/crvs-id-input.configuration';
import {
  genericDataFetchFieldParseFieldIntoDisplayFormModel,
  genericDataFetchFieldParseIntoSettingsFormModel,
  genericDataFetchFieldParseIntoValidationFormModel,
  genericDataFetchFieldUpdateFromDisplayFormModel,
  genericDataFetchFieldUpdateFromSettingsFormModel,
  genericDataFetchFieldUpdateFromValidationFormModel,
  genericDataFetchInputGetConfigurationConfig,
  IGenericDataFetchConfigurationFormModel,
} from './form-field-formly-types-main-configurations/generic-datafetch-field-type.configuration';
import {
  applicationNumberFieldParseFieldIntoDisplayFormModel,
  applicationNumberFieldParseIntoSettingsFormModel,
  applicationNumberFieldParseIntoValidationFormModel,
  applicationNumberFieldUpdateFromDisplayFormModel,
  applicationNumberFieldUpdateFromSettingsFormModel,
  applicationNumberFieldUpdateFromValidationFormModel,
  applicationNumberGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/application-number-field-type.configuration';
import {
  sectionMessageFieldParseFieldIntoDisplayFormModel,
  sectionMessageFieldParseIntoSettingsFormModel,
  sectionMessageFieldUpdateFromDisplayFormModel,
  sectionMessageFieldUpdateFromSettingsFormModel,
  sectionMessageWithLinkGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/custom-section-with-message.configuration';
import {
  doubleIdInputFieldParseFieldIntoDisplayFormModel,
  doubleIdInputFieldParseIntoSettingsFormModel,
  doubleIdInputFieldParseIntoValidationFormModel,
  doubleIdInputFieldUpdateFromDisplayFormModel,
  doubleIdInputFieldUpdateFromSettingsFormModel,
  doubleIdInputFieldUpdateFromValidationFormModel,
  doubleIdInputGetConfigurationConfig,
} from './form-field-formly-types-main-configurations/double-id-field-type.configurator';
import {
  checkboxFieldGetConfigurationConfig,
  checkboxFieldParseFieldIntoDisplayFormModel,
  checkboxFieldParseIntoSettingsFormModel,
  checkboxFieldParseIntoValidationFormModel,
  checkboxFieldUpdateFromDisplayFormModel,
  checkboxFieldUpdateFromSettingsFormModel,
  checkboxFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/checkbox-field-type.configuration';
import {
  tableWrapperFieldGetConfigurationConfig,
  tableWrapperFieldParseIntoSettingsFormModel,
  tableWrapperFieldUpdateFromSettingsFormModel,
  tableWrapperFieldParseIntoValidationFormModel,
  tableWrapperFieldUpdateFromValidationFormModel,
  tableWrapperFieldParseIntoDisplayFormModel,
  tableWrapperFieldUpdateFromDisplayFormModel,
} from './form-field-formly-types-main-configurations/table-wrapper-field-type.configuration';
import {
  dataTableFieldGetConfigurationConfig,
  dataTableFieldParseFieldIntoDisplayFormModel,
  dataTableFieldParseIntoSettingsFormModel,
  dataTableFieldUpdateFromDisplayFormModel,
  dataTableFieldUpdateFromSettingsFormModel,
  dataTableFieldUpdateFromValidationFormModel,
  dataTableParseIntoValidationFormModel,
} from './form-field-formly-types-main-configurations/data-table-field-type.configurator';
import {
  dateTimePickerFieldGetConfiguration,
  dateTimePickerFieldParseIntoSettingsFormModel,
  dateTimePickerFieldUpdateFromSettingsFormModel,
  dateTimePickerFieldParseIntoValidationFormModel,
  dateTimePickerFieldUpdateFromValidationFormModel,
  dateTimePickerFieldParseFieldIntoDisplayFormModel,
  dateTimePickerFieldUpdateFromDisplayFormModel,
} from './form-field-formly-types-main-configurations/custom-datetimepicker-field.configuration';
import {
  errorCompnentFromSettingsFormModel,
  errorCompnentParseIntoSettingsFormModel,
  errorComponentGetConfiguration,
} from './form-field-formly-types-main-configurations/custom-error.configuration';

import {
  timePickerFieldGetConfiguration,
  timePickerFieldParseIntoSettingsFormModel,
  timePickerFieldUpdateFromSettingsFormModel,
} from './form-field-formly-types-main-configurations/custom-timepicker-field-type.configuration';
import {
  currencyFormatInputFieldGetConfigurationConfig,
  currencyFormatInputFieldParseIntoSettingsFormModel,
  currencyFormatInputFieldUpdateFromSettingsFormModel,
  currencyFormatInputFieldParseFieldIntoDisplayFormModel,
  currencyFormatInputFieldUpdateFromDisplayFormModel,
  currencyFormatInputFieldParseIntoValidationFormModel,
  currencyFormatInputFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-currency-format-field-type.configuration';

import {
  IOtpDataFetchConfigurationFormModel,
  otpDataFetchInputGetConfigurationConfig,
  otpDataFetchFieldParseIntoSettingsFormModel,
  otpDataFetchFieldUpdateFromSettingsFormModel,
  otpDataFetchFieldParseFieldIntoDisplayFormModel,
  otpDataFetchFieldUpdateFromDisplayFormModel,
  otpDataFetchFieldParseIntoValidationFormModel,
  otpDataFetchFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-otp-data-fetch-field-type.configuration';

import {
  customRepeaterFieldGetConfigurationConfig,
  customRepeaterFieldParseIntoSettingsFormModel,
  customRepeaterFieldUpdateFromSettingsFormModel,
  customRepeaterFieldParseIntoValidationFormModel,
  customRepeaterFieldParseFieldIntoDisplayFormModel,
  customRepeaterFieldUpdateFromDisplayFormModel,
  customRepeaterFieldUpdateFromValidationFormModel,
} from './form-field-formly-types-main-configurations/custom-repeater-field-type.configuration';

import {
  tableWithInputFieldGetConfigurationConfig,
  tableWithInputFieldParseIntoSettingsFormModel,
  tableWithInputFieldUpdateFromSettingsFormModel,
  tableWithInputFieldParseIntoValidationFormModel,
  tableWithInputFieldUpdateFromValidationFormModel,
  tableWithInputFieldParseIntoDisplayFormModel,
  tableWithInputFieldUpdateFromDisplayFormModel,
} from './form-field-formly-types-main-configurations/table-with-input-field-type.configuration';
import {
  ADVANCED_FORM_FIELD_TYPES,
  AdvancedFormlyFieldConfiguration,
} from './form-field-formly-types-main-configurations/form-field-formly-configuration-classes/advanced-formly-field-configuration';

export class FormBuilderFieldConfigurationParserAndSetterClass {
  formBuilderService!: FormBuilderService;

  constructor(private injector: Injector) {
    this.formBuilderService = this.injector.get(FormBuilderService);
  }

  getFormlyFieldConfigurationConfigByType = (
    fieldType: string | undefined,
    subType?: EIremboFormlyFieldSubTypes | undefined
  ): IFormbuilderFieldTypeConfiguration => {
    switch (fieldType) {
      case EIremboFormlyFieldTypes.block:
        return blockFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.input:
        return inputFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customdropdown:
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH
        ) {
          return customDropDownWithDataFetchFieldGetConfigurationConfig(
            this.formBuilderService
          );
        }
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET
        ) {
          return customDropDownWithDataSetFieldNonPaginatedGetConfigurationConfig(
            this.formBuilderService
          );
        }
        return customDropDownFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        if (
          subType ===
          EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED
        ) {
          return customDropDownWithDataFetchFieldGetConfigurationConfig(
            this.formBuilderService
          );
        }
        if (
          subType ===
          EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED
        ) {
          return customDropDownWithDatasetFieldGetConfigurationConfig(
            this.formBuilderService
          );
        }
        return customDropDownFieldGetConfigurationConfig(
          this.formBuilderService
        );

      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.radio:
        return radioFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customidinput:
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NID
        ) {
          return nidFieldGetConfigurationConfig(this.formBuilderService);
        }
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_CHILD_ID
        ) {
          return childNidFieldGetConfigurationConfig(this.formBuilderService);
        }
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_ID_INPUT_NIN
        ) {
          return ninFieldGetConfigurationConfig(this.formBuilderService);
        }
        return sectionFieldGetConfigurationConfig(this.formBuilderService);

      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customdatepicker:
        return datePickerFieldGetSettingsConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customslotbooking:
        return slotbookingGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customtininput:
        return tinInputGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsInputGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchInputGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customsectionmessagewithlink:
        return sectionMessageWithLinkGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableFieldGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldGetConfiguration(this.formBuilderService);
      case EIremboFormlyFieldTypes.customerrorcomponent:
        return errorComponentGetConfiguration(this.formBuilderService);
      case EIremboFormlyFieldTypes.customtimepicker:
        return timePickerFieldGetConfiguration(this.formBuilderService);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchInputGetConfigurationConfig(this.formBuilderService);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldGetConfigurationConfig(
          this.formBuilderService
        );
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldGetConfigurationConfig(
          this.formBuilderService
        );
      default:
        return sectionFieldGetConfigurationConfig(this.formBuilderService);
    }
  };

  parseFieldIntoSettingsFormModelByType = (
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): TConfigurationFormModelTypes => {
    const subType: EIremboFormlyFieldSubTypes = field.props?.['subType'];
    switch (fieldType) {
      case EIremboFormlyFieldTypes.block:
        return blockFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.input:
        return inputFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdropdown:
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH
        ) {
          return customDropDownWithDataFetchFieldParseIntoSettingsFormModel(
            field
          );
        }
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET
        ) {
          return customDropDownWithDatasetFieldParseIntoSettingsFormModel(
            field
          );
        }

        return customDropDownFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        if (
          subType &&
          subType ===
            EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED
        ) {
          return customDropDownWithDataFetchFieldParseIntoSettingsFormModel(
            field
          );
        }
        if (
          subType &&
          subType ===
            EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED
        ) {
          return customDropDownWithDatasetFieldParseIntoSettingsFormModel(
            field
          );
        }

        return customDropDownFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.radio:
        return radioFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdatepicker:
        return datePickerFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customslotbooking:
        return slotBookingFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customsectionmessagewithlink:
        return sectionMessageFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customerrorcomponent:
        return errorCompnentParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customtimepicker:
        return timePickerFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldParseIntoSettingsFormModel(field);
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldParseIntoSettingsFormModel(field);
      default:
        return sectionFieldParseIntoSettingsFormModel(field);
    }
  };

  updateFieldFromSettingsFormModel = (
    model: TConfigurationFormModelTypes,
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): FormlyFieldConfig => {
    if (
      ADVANCED_FORM_FIELD_TYPES.includes(fieldType as EIremboFormlyFieldTypes)
    ) {
      return new AdvancedFormlyFieldConfiguration(
        this.injector,
        field
      ).updateFieldConfigFromSettingsFormModel(model);
    }

    const subType: EIremboFormlyFieldSubTypes = field.props?.['subType'];
    switch (fieldType) {
      case EIremboFormlyFieldTypes.block:
        return blockFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.input:
        return inputFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customdropdown:
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH
        ) {
          return customDropDownWithDataFetchFieldUpdateFromSettingsFormModel(
            model as IGenericDataFetchFieldsConfigFormModel,
            field
          );
        }
        if (
          subType &&
          subType === EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET
        ) {
          return customDropDownWithDatasetFieldUpdateFromSettingsFormModel(
            model as IGenericDataFetchFieldsConfigFormModel,
            field
          );
        }
        return customDropDownFieldUpdateFromSettingsFormModel(
          model as IGenericLabelValueFieldsConfigFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        if (
          subType &&
          subType ===
            EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATAFETCH_PAGINATED
        ) {
          return customDropDownWithDataFetchFieldUpdateFromSettingsFormModel(
            model as IGenericDataFetchFieldsConfigFormModel,
            field
          );
        }
        if (
          subType &&
          subType ===
            EIremboFormlyFieldSubTypes.CUSTOM_DROPDOWN_DATASET_PAGINATED
        ) {
          return customDropDownWithDatasetFieldUpdateFromSettingsFormModel(
            model as IGenericDataFetchFieldsConfigFormModel,
            field
          );
        }
        return customDropDownWithDatasetFieldUpdateFromSettingsFormModel(
          model as IGenericDataFetchFieldsConfigFormModel,
          field
        );

      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldUpdateFromSettingsFormModel(
          model as IGenericLabelValueFieldsConfigFormModel,
          field
        );
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldUpdateFromSettingsFormModel(
          model as IGenericLabelValueFieldsConfigFormModel,
          field
        );
      case EIremboFormlyFieldTypes.radio:
        return radioFieldUpdateFromSettingsFormModel(
          model as IGenericLabelValueFieldsConfigFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldUpdateFromSettingsFormModel(
          model as IGenericLabelValueFieldsConfigFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customslotbooking:
        return slotBookingFieldUpdateFromSettingsFormModel(model, field);

      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldUpdateFromSettingsFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customdatepicker:
        return datePickerFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldUpdateFromSettingsFormModel(
          model as IGenericDataFetchConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customsectionmessagewithlink:
        return sectionMessageFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldUpdateFromSettingsFormModel(
          model as ITableWrapperConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customdatatable: {
        return dataTableFieldUpdateFromSettingsFormModel(
          model as IDataTableFieldConfigurationFormModel,
          field
        );
      }
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldUpdateFromSettingsFormModel(
          model as ICustomDynamicRepeaterConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldUpdateFromSettingsFormModel(model, field);
      case EIremboFormlyFieldTypes.customerrorcomponent:
        return errorCompnentFromSettingsFormModel(
          model as IErrorConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customtimepicker:
        return timePickerFieldUpdateFromSettingsFormModel(
          model as ITimePickerFieldConfig,
          field
        );
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldUpdateFromSettingsFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldUpdateFromSettingsFormModel(
          model as IOtpDataFetchConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldUpdateFromSettingsFormModel(
          model as ICustomRepeaterConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldUpdateFromSettingsFormModel(
          model as ITableWithInputConfigurationFormModel,
          field
        );
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
      default:
        return sectionFieldUpdateFromSettingsFormModel(model, field);
    }
  };

  generateWidgetFieldsFromSettingsFormModel = (
    model: TConfigurationFormModelTypes,
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): FormlyFieldConfig[] => {
    switch (fieldType) {
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldUpdateFromSettingsFormModel(model, field);
      default:
        return [field];
    }
  };

  parseFieldIntoValidationFormModelByType = (
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): IFormFieldsValidationModel => {
    switch (fieldType) {
      case EIremboFormlyFieldTypes.input:
        return inputFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdropdown:
        return customDropDownFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        return customDropDownFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.radio:
        return radioFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdatepicker:
        return datePickerFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldParseIntoValidationFormModel(field);
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldParseIntoValidationFormModel(field);
      default:
        return {};
    }
  };

  updateFieldFromValidationsFormModel = (
    model: IFormFieldsValidationModel,
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): FormlyFieldConfig => {
    switch (fieldType) {
      case EIremboFormlyFieldTypes.input:
        return inputFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdropdown:
        return customDropDownFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.radio:
        return radioFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldUpdateFromValidationFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        return customDropDownFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldUpdateFromValidationFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldUpdateFromValidationFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customdatepicker:
        return datePickerFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldUpdateFromValidationFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldUpdateFromValidationFormModel(model, field);
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldUpdateFromValidationFormModel(model, field);
      default:
        return field;
    }
  };

  parseFieldIntoDisplayFormModel(
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): IFormFieldsDisplayModel {
    switch (fieldType) {
      case EIremboFormlyFieldTypes['formly-group']:
        return sectionFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.block:
        return blockFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.input:
        return inputFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdropdown:
        return customDropDownFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.radio:
        return radioFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldParseFieldIntoDisplayFormModel(
          field
        );
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        return customDropDownFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customsectionmessagewithlink:
        return sectionMessageFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldParseIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldParseFieldIntoDisplayFormModel(field);
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldParseIntoDisplayFormModel(field);
      default:
        return {};
    }
  }

  updateFieldFromDisplayFormModel = (
    model: IFormFieldsDisplayModel,
    field: FormlyFieldConfig,
    fieldType: string | undefined
  ): FormlyFieldConfig => {
    switch (fieldType) {
      case EIremboFormlyFieldTypes['formly-group']:
        return sectionFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.block:
        return blockFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.input:
        return inputFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.textarea:
        return textareaFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdropdown:
        return customDropDownFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.checkbox:
        return checkboxFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.multicheckbox:
        return multiCheckboxFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.radio:
        return radioFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customidinput:
        return nidFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customfileupload:
        return customFileUploadFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customphonenumber:
        return internationalPhoneNumberFieldUpdateFromDisplayFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customcascadingdropdowns:
        return locationWidgetFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdropdownpaginated:
        return customDropDownFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customtininput:
        return tinFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customcrvsidinput:
        return crvsFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customgenericdatafetch:
        return genericDataFetchFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customapplicationnumberinput:
        return applicationNumberFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customsectionmessagewithlink:
        return sectionMessageFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdoubleidinput:
        return doubleIdInputFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatasettable:
        return tableWrapperFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdatatable:
        return dataTableFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customdynamicrepeater:
        return customDynamicRepeaterFieldUpdateFromDisplayFormModel(
          model,
          field
        );
      case EIremboFormlyFieldTypes.customdatetimepicker:
        return dateTimePickerFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customcurrencyformatinput:
        return currencyFormatInputFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customotpdatafetch:
        return otpDataFetchFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customrepeater:
        return customRepeaterFieldUpdateFromDisplayFormModel(model, field);
      case EIremboFormlyFieldTypes.customtablewithinputform:
        return tableWithInputFieldUpdateFromDisplayFormModel(model, field);
      default:
        return field;
    }
  };
}
